import React, { useEffect, useState } from "react";
import { Grid, Button, Card, Switch  } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import { makeStyles } from "@material-ui/core/styles";
import { fetchCoseguros, guardarCoseguro } from "../../../../actions/contrataciones/configuraciones/abmCoseguros";
import FormCoseguros from "./FormCoseguros";
import moment from 'moment';
import ModalHistoricoTrackingAbm from "../../../compartidos/abms/ModalHistoricoTrackingAbm";
import InfoHistorialIcon from "../../../autorizaciones/UI/InfoHistorialIcon";
import { TIPO_TRACKING_ABM } from "../../../../utils/constants";
import { CONFIGURACION_CONTRATOS } from "../../../../utils/permisos";


const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

export const HomeCoseguros = (props) => {
  const { items = [] } = useSelector((state) => state.abmCoseguros);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openModalAlta, setOpenModalAlta] = useState(false);
  const [itemForm, setItemForm] = useState(false);

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);

  useEffect(() => {
    dispatch(fetchCoseguros());
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(fetchCoseguros(textoBuscado));
  }

  const handleItemSelect = (item) => {
    setItemForm(item)
    setOpen(true)
  }

  const handleSave = (item) => {
    const data = {
      descripcion: item.descripcion,
      tope: item.tope,
      defaultCantidad:item.defaultCantidad ? 1 : 0,
      saltaPago: item.saltaPago,
      fechaDesde: item.valores.fechaDesde,
      //fechaHasta: item.valores.fechaHasta,
      valor: item.valores.valor,
      valorExcede: item.valores.valorExcede,
      valorExterno: (item.valores.valorExterno === "" ? null : item.valores.valorExterno),
      valorExcedeExterno: (item.valores.valorExcedeExterno === "" ? null : item.valores.valorExcedeExterno),
      idGrupo: item.valores.idGrupo,
      nuevoPeriodo: item.nuevoPeriodo === null ? false : item.nuevoPeriodo,
      grupo: item.grupo
    }

    if (item.valores.idGrupo) {
      dispatch(guardarCoseguro(item.valores.idGrupo, data));
    } else {
      dispatch(guardarCoseguro(null, data));
    }
  };

  const handleDelete = (item) => {
    
  }

  const intialValue = {
    descripcion: "",
    tope: 0,
    defaultCantidad: 0,
    saltaPago: false,
    nuevoPeriodo: false,
    valores: {
      fechaDesde: moment(),
      //fechaHasta: new Date(3000, 11, 31),
      valor: 0,
      valorExcede: 0,
      valorExterno: null,
      valorExcedeExterno: null,
      idGrupo: null,
      grupo: null
    }
  }

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Coseguro" open={openModalAlta} setOpen={setOpenModalAlta}>
          <FormCoseguros formData={intialValue} handleSave={handleSave} cerrarModal={() => setOpenModalAlta(false)} permisoAlta={CONFIGURACION_CONTRATOS.ALTA} editando={false} />
        </ModalAbm>
        <ModalAbm title="Modificar Coseguro" open={open} setOpen={setOpen}>
          <FormCoseguros formData={itemForm} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={CONFIGURACION_CONTRATOS.MODIFICACION} editando={true} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setOpenModalAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Coseguro</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Coseguro" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={11} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label: "",
                  id: "",
                  sort: false,
                  customBody: (item) => ((moment(item.valores.fechaHasta).format('DD/MM/YYYY') === "31/12/3000") &&
                  <InfoHistorialIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setIdClave(item?.grupo);
                        setDescripcion(`${item?.grupo} - ${item?.descripcion}`);
                      }}
                    />
                  ),
                },
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleItemSelect}
                      permisoDelete={CONFIGURACION_CONTRATOS.BAJA}
                      handleDelete={handleDelete}
                      showSelect={moment(item.valores.fechaHasta).format('DD/MM/YYYY') === "31/12/3000"}
                      showDelete={false}
                    />
                  )
                },
                {
                  label: "Descripcion grupo",
                  id: "descripcion",
                  sort: true
                },
                {
                  label: "Tope",
                  id: "tope",
                  sort: true
                },
                {
                  label: "Fecha desde",
                  id: "valores.fechaDesde",
                  sort: true,
                  customBody: (item) => item.valores.fechaDesde ? moment(item.valores.fechaDesde).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Fecha hasta",
                  id: "valores.fechaHasta",
                  sort: true,
                  customBody: (item) => item.valores.fechaHasta ? (moment(item.valores.fechaHasta).format('DD/MM/YYYY') === "31/12/3000" ? "VIGENTE" : moment(item.valores.fechaHasta).format('DD/MM/YYYY')) : ""
                },
                {
                  label: "Valor",
                  id: "valores.valor",
                  sort: true
                },
                {
                  label: "Valor excede",
                  id: "valores.valorExcede",
                  sort: true
                },
                {
                  label: "Marca en asistencia",
                  id: "defaultCantidad",
                  sort: true,
                  customBody: (item) => (
                    <Switch
                      checked={item?.defaultCantidad}
                      value={item?.defaultCantidad}
                      name="defaultCantidad"
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                  ),
                  
                },
                {
                  label: "Salta pago",
                  id: "saltaPago",
                  sort: true,
                  customBody: (item) => (
                    <Switch
                      checked={item?.saltaPago}
                      value={item?.saltaPago}
                      name="saltaPago"
                      //onChange={(e) => handleChangeSwitch(e, item)}
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />
                  ),
                  
                },
                {
                  label: "Valor externo",
                  id: "valores.valorExterno",
                  sort: true
                },
                {
                  label: "Valor excede externo",
                  id: "valores.valorExcedeExterno",
                  sort: true
                },
              ]}
            />
            {openModalInfo && (
              <ModalHistoricoTrackingAbm
                open={openModalInfo}
                onClose={() => setOpenModalInfo(false)}
                idClave={idClave}
                descripcion={descripcion}
                tipoTrackingId={TIPO_TRACKING_ABM.GRUPO_COSEGURO}
                showCampo={true}
              />
              )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};

export default HomeCoseguros; 
